import React from 'react';
import SearchSimple from '../../../../../../components/SearchSimples/SearchSimple';
import CustomTable from '../../../../../../components/table/CustomTable';
import PayrollActiveTableApp from '../Functionality/PayrollActiveTableApp';
import PayrollSubViewOptions from '../PayrollUserDetails/SubComponents/PayrollSubViewOptions';
import {IconScheduleTable} from "../../../../../../components/buttons/IconButtons";
import {POSITION_MODEL} from "../../../../../../Helpers/PositionModel";
import CustomUserChip from "../../../../../../components/CustomUserChip";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * Payroll list for the active period.
 */
const PayrollActiveTable = ({
    subView,
    changeSubView,
    option,
    setBodyForExport,
    searchElement,
    setSearchElement,
    setSimpleSearch,
    search,
    setSearch,
    modified,
    setModified,
    activeStep,
    registerAction,
}) => {

    const {
        t,
        setResults,
        rowsPerPage,
        tableId,
        searchId,
        thead,
        tbody,
        pagination,
        getActionsButtons,
        textNotInformation,
        periodStart,
        periodEnd,
        periodEndTime
    } = PayrollActiveTableApp({
        searchElement,
        setBodyForExport,
        option,
        modified,
        setModified,
        activeStep,
        registerAction,
        subView
    });

    return (
        <>
            <div className='d-flex align-items-center gap-3 mb-4'>
                <PayrollSubViewOptions subView={subView} changeSubView={changeSubView} />
                <div className='w-100'>
                    <SearchSimple
                        id={searchId}
                        setBodyForExport={setBodyForExport}
                        setSearchResults={setResults}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        search={search}
                        setSearch={setSearch}
                        rowsPerPage={rowsPerPage}
                        setSimpleSearch={setSimpleSearch}
                        contractorId={null}
                        supplierId={null}
                    />
                </div>
            </div>
            { tbody?.data?.length > 0 &&
                <CustomUserChip
                    id={'chip_pat_active_period'}
                    name={t('active_period_range', { start: periodStart, end: periodEnd, endTime: periodEndTime })}
                    showAvatar={true}
                    Icon={IconScheduleTable}
                    iconPosition={POSITION_MODEL.LEFT}
                    className={'chip-secondary-150-100 w-100 m-0'}
                    classNameIcon={'icon-color-secondary-700'}
                    variant='large'
                    />
            }

            <CustomTable
                tableId={tableId}
                searchId={searchId}
                checkbox={false}
                thead={thead}
                tbody={tbody}
                columnActions={true}
                getActionsButtons={getActionsButtons}
                textNotInformation={textNotInformation}
            />
            {pagination()}
        </>
    );
};

export default PayrollActiveTable;
